import { Loader } from '@unmind/design-system';
import { rem } from 'polished';
import styled from 'styled-components';

export const StyledLoader = styled(Loader)`
  margin: 0 ${rem(20)} ${rem(20)};
`;
